import React from 'react';
import PropTypes from 'prop-types';

/**
 * SVG-иконка из react-icons (набор Material Design / md).
 */
function MaterialIcon({ icon: Icon, className, size, 'aria-hidden': ariaHidden }) {
  if (!Icon) return null;
  return <Icon className={className} size={size} aria-hidden={ariaHidden} />;
}

MaterialIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  'aria-hidden': PropTypes.bool,
};

MaterialIcon.defaultProps = {
  className: undefined,
  size: '1em',
  'aria-hidden': true,
};

export default MaterialIcon;
